import { ref, watch, computed } from 'vue';
import { IRSTORE_T_VIEW } from '@/utils/track';
import { useCommonData } from '@/hooks';
import { useModuleConfig } from '@rebuild/hooks/data/useModuleConfig';
import store from '@/store';
import route from '@/router';
import { resolveStoreId, resolvePageId } from '@rebuild/utils/context';

export const useCalendarCommon = () => {
	const fromQuickTmpl = computed(() => {
		const s = route.currentRoute.meta?.source;
		return s === 'pureModule';
	});
    
	const { getSurveyEntry } = useCommonData();
	const showSurveyEntry = ref(false);
	watch(
		() => getSurveyEntry.value,
		val => {
			showSurveyEntry.value = val && !fromQuickTmpl.value;
		},
		{ immediate: true }
	);

	const visibleSurvey = ref(false);

	const handleAppointment = () => {
		IRSTORE_T_VIEW(282, {
			params: {
				浏览模块名称: '预约调研',
				浏览模块类型: '系统默认模块',
				企业ID: resolveStoreId(),
				页面ID: resolvePageId()
			}
		});
		visibleSurvey.value = true;
	};

	const getModuleName = moduleId => {
		const allModules = store.getters.getPageAllModules;
		const module = allModules.find(m => m.moduleId === moduleId);
		return module?.name || '';
	};
	const { config, loadModuleConfig } = useModuleConfig();
	const initCalendarConfig = async () => {
		await loadModuleConfig('customs_calendar');
		const tab = config.value?.tab || [];
		store.commit('updateModulesConfig', {
			moduleId: 'customs_calendar',
			config: {
				tab
			}
		});
	};

	const getCalendarName = id => {
		const calendarConfig = store.state.modulesConfig['customs_calendar'];
		const calendarTabs = calendarConfig?.tab || [];
		const findCalendar = calendarTabs.find(item => item.id == id);
		return findCalendar?.name || '-';
	};

	return {
		visibleSurvey,
		showSurveyEntry,
		handleAppointment,
		getModuleName,
		initCalendarConfig,
		getCalendarName
	};
};
